import { Controller, Shark, Utils } from "shark-mvc";
import { NousCore } from "nouscore-js-api";
import moment from "moment-business-days";

import followUpManager from "./followUpManager";
import { documentManager } from "./documentManager";
import { folderManager } from "./folderManager";
import { userManager } from "./userManager";

class ConstructionSiteManager extends Controller {
	constructor () {
		super("constructionSiteManager");

		this.remoteClassName = "construction-site";
	}

	confirmClosing (constructionSite) {
		const rd = NousCore.api.createRequest({
			item: { 
				guid: constructionSite.guid,
				comment: constructionSite.__closeComment,
				confirmedClosingDate: moment.utc(constructionSite.__confirmedClosingDate).format(Shark.get("dateISODateTimeFormat")),
				ncrNotes: constructionSite.__ncrNotes,
				ncrSuccessfullyManaged: constructionSite.__ncrSuccessfullyManaged,
				teamCloseDocumentGuid: constructionSite.teamCloseDocumentGuid,
			}
		});
		const requestedAction = "confirm-closing-remote";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						return {
							data,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data,
							error: data.error,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getByCCA (cca) {
		const rd = NousCore.api.createRequest({ item: { cca } });
		const requestedAction = "get-by-cca";
	
		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const constructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);
	
						return {
							data: constructionSiteList,
							requestedAction,
							status: "ok"
						};
					case 404:
						return {
							data: "",
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	getFilteredList ({incrementalRequest, filters, range} = {incrementalRequest: false, filters: null, range: null}) {
		const rd = NousCore.api.createRequest();
		const requestedAction = "get-filtered-list";

		if (range) {
			rd.range = range;
		}

		if (filters) {
			rd.filters = filters;
		}

		return NousCore.api.send(`${this.remoteClassName}/${requestedAction}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						let constructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);

						if (incrementalRequest) {
							constructionSiteList = [...Shark.get("constructionSiteList"), ...constructionSiteList];
						}
						const constructionSiteGroupsMap = {};


						constructionSiteList.sort((a, b) => {
							if (a.quotationGuid > b.quotationGuid) {
								return -1;
							}
							else if (a.quotationGuid < b.quotationGuid) {
								return 1;
							}
						});

						constructionSiteList.forEach(item => {
							if (constructionSiteGroupsMap[item.quotationGuid]) {
								constructionSiteGroupsMap[item.quotationGuid].push(item);
							}
							else {
								constructionSiteGroupsMap[item.quotationGuid] = [item];
							}
						});

						const constructionSiteGroupList = Object.values(constructionSiteGroupsMap);

						constructionSiteGroupList.forEach(group => {
							group.sort((a, b) => {
								if (a.updatedAt > b.updatedAt) {
									return -1;
								}
								else if (a.updatedAt < b.updatedAt) {
									return 1;
								}
							});

							// group[0].__groupCSSClass = "firstOfGroup";
							
							// if (group.length > 1) {
							// 	group[group.length - 1].__groupCSSClass = "lastOfGroup";
							// }
						});

						let counter = 1;
						constructionSiteGroupList.forEach((group, groupIndex) => {
							group.forEach((item, itemIndex) => {
								item.__displayIndex = (counter++);
							});
						});


						constructionSiteList.sort((a, b) => {
							if (a.updatedAt > b.updatedAt) {
								return -1;
							}
							else if (a.updatedAt < b.updatedAt) {
								return 1;
							}
						});

						const constructionSiteListProvinceForFilter = new Set();
						constructionSiteList.forEach(item => item.registry.clientProvince !== "" ? constructionSiteListProvinceForFilter.add(item.registry.clientProvince) : false);

						Shark.set({
							constructionSiteList,
							constructionSiteListProvinceForFilter: Array.from(constructionSiteListProvinceForFilter).sort(),
							constructionSiteGroupList,
							__constructionSiteListNeedFurtherLoad: data.availableItemCount > constructionSiteList.length,
							__availableFurtherItems: data.availableItemCount - constructionSiteList.length,
						});

						constructionSiteManager.emit("listChanged");
						return {
							data: constructionSiteList,
							requestedAction,
							status: "ok"
						};
					case 404:
						constructionSiteManager.emit("listGetError");
						return {
							data,
							error: data.error,
							requestedAction,
							status: "ko"
						};
				}
			}
		});
	}

	// getLatest () {
	// 	const rd = NousCore.api.createRequest();
	// 	const action = "get-latest";
	
	// 	return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
	// 	.then(data => {
	// 		if (data.isSuccess) {
	// 			switch (data.rc) {
	// 				case 1:
	// 					const latestConstructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);
						
	// 					Shark.set({
	// 						latestConstructionSiteList
	// 					});
	
	// 					return {
	// 						data: latestConstructionSiteList,
	// 						requestedAction: action,
	// 						status: "ok"
	// 					};
	// 				case 404:
	// 					return {
	// 						data,
	// 						requestedAction: action,
	// 						status: "ko"
	// 					};
	// 			}
	// 		}
	// 	});
	// }



	
	getByConstructionSiteCardGuid (constructionSiteCardGuid) {
		const rd = NousCore.api.createRequest({ item: {guid: constructionSiteCardGuid} });

		return NousCore.api.send("construction-site/get-by-construction-site-card-guid", rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						const constructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);

						return {
							data: constructionSiteList,
							status: "ok"
						}
						break;
					case 404:
						return {
							data: null,
							status: "ko"
						}
						break;
				}
			}
		});
	}





		
	save (constructionSite) {
		const rd = NousCore.api.createRequest({ item: constructionSite.export() });
		const action = constructionSite.guid === "" ? "insert" : "update";

		return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
		.then(data => {
			if (data.isSuccess) {
				switch (data.rc) {
					case 1:
						constructionSite.import(data.items[0]);
						constructionSite.clean();

						const currUser = Shark.get("currUser");

						if (action === "insert") {
							return folderManager.getByReference(constructionSite.extraData.relatedGuids.siteInfoSheetGuid)
							.then(existingClientSubFoldersResponse => {
								const projectFolder = existingClientSubFoldersResponse.data[0];

								if (projectFolder) {
									// folderManager.getList(projectFolder)
									// .then(projectSubFoldersResponse => {
										// console.log({projectFolder, projectSubFoldersResponse});

										//Dave: Lo sposto in creazione CSC così che in IPM possano cominciare a mettere dentro materiale.
										// const newConstructioSIteFolder = Shark.getInstance("Folder", {
										// 	clientGuid: constructionSite.extraData.relatedGuids.clientGuid,
										// 	name: "Materiali Cantiere",
										// 	ownerGuid: currUser.guid,
										// 	parentGuid: projectFolder.guid,
										// 	referenceGuid: constructionSite.guid,
										// 	referenceType: "constructionSite",
										// 	status: 1,
										// 	type: "constructionSite",
										// });
										// folderManager.save(newConstructioSIteFolder)
										// .then(saveProjectFolderResponse => {
										// });

										const newFollowUp = Shark.getInstance("ClientFollowUp", {
											body: "Confermata la partenza del cantiere.",
											clientGuid: constructionSite.extraData.relatedGuids.clientGuid,
											referenceGuid: constructionSite.guid,
											referenceType: "constructionSite",
											status: 3,
											type: "system"
										});
										console.log(newFollowUp);
								
										followUpManager.save(newFollowUp)
										.then(saveFollowUpResponse => {
											console.log({saveFollowUpResponse});

											return {
												data: constructionSite,
												requestedAction: action,
												status: "ok"
											};
										});

										const body = `BuonGiorno Barbara,
							
											questa eMail per comunicare che ${currUser.__fullName}, ha confermato la partenza del cantiere per il cliente ${constructionSite.registry.clientName}.
								
											Puoi visualizzare la lista dei Cantieri attivi <a href="${Shark.get("extranetURL")}/#constructionSiteListView">cliccando qui</a>.
								
											Buona Giornata,
											IPM HUB
										`;
							
										const currMessage = Shark.getInstance(null, {
											body,
											senderEMail: currUser.email,
											senderName: currUser.__fullName,
											subject: "IPM HUB | Nuovo Cantiere confermato",
											receiverEMail: "barbara.marinelli@ipmitalia.it",
											receiverName: "Barbara Marinelli",
										});
										userManager.sendMessage(currMessage);
									// });
								}

								return {
									data: constructionSite,
									requestedAction: action,
									status: "ok"
								};		
							});
						}
						else {
							//È un update, verifico se va cambiato qualcosa
							// folderManager.getByReference(siteInfoSheet.guid)
							// .then(siteInfoSheetFolderResponse => {
							if (constructionSite.extraData.relatedGuids.siteInfoSheetGuid !== "") {
								folderManager.getByReference(constructionSite.extraData.relatedGuids.siteInfoSheetGuid)
								.then(existingClientSubFoldersResponse => {
									const projectFolder = existingClientSubFoldersResponse.data.filter(item => item.type === "siteInfoSheet")[0];
									const siteInspectionFolder = existingClientSubFoldersResponse.data.filter(item => item.type === "siteInspection")[0];


									if (siteInspectionFolder) {
										documentManager.getList(siteInspectionFolder)
										.then(siteInspectionFolderDocumentsResponse => {
											const documentList = siteInspectionFolderDocumentsResponse.data;

											documentList.forEach(document => {
												if (document.source === "constructionSite") {
													const existing = Utils.safp(constructionSite.attachments, "url", document.fileURL);
													if (!existing) {
														documentManager.delete(document)
														.then(nousResponse => {
															console.log("Cancellato il file", document);
														});
													}
												}
											});

										});
									}
								});
							}
						}

						// constructionSiteManager.emit("saved");
						return {
							data: constructionSite,
							requestedAction: action,
							status: "ok"
						};
						break;
					case 99:
						// constructionSiteManager.emit("saveError");
						return {
							data: "",
							status: "ko"
						};
				}
			}
		});
	}

}

const constructionSiteManager = new ConstructionSiteManager();

// constructionSiteManager.addMethod("close", function (constructionSite) {
// 	const rd = NousCore.api.createRequest( {item: constructionSite.export()} );
// 	const action = "close";

// 	return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
// 	.then(data => {
// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
// 					constructionSite.import(data.items[0]);
// 					constructionSite.clean();

// 					return {
// 						data: constructionSite,
// 						requestedAction: action,
// 						status: "ok"
// 					};
// 				case 404:
// 					constructionSiteManager.emit("listGetError");
// 					return {
// 						data,
// 						error: data.error,
// 						requestedAction: action,
// 						status: "ko"
// 					};
// 			}
// 		}
// 	});
// });

// constructionSiteManager.addMethod("getLatestForAgent", function () {
// 	const rd = NousCore.api.createRequest();
// 	const action = "get-latest-for-agent";

// 	return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
// 	.then(data => {
// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
// 					const latestConstructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);
					
// 					Shark.set({
// 						latestConstructionSiteList
// 					});

// 					return {
// 						data: latestConstructionSiteList,
// 						requestedAction: action,
// 						status: "ok"
// 					};
// 				case 404:
// 					return {
// 						data,
// 						requestedAction: action,
// 						status: "ko"
// 					};
// 			}
// 		}
// 	});
// });

// constructionSiteManager.addMethod("getList", function (user) {
// 	const rd = NousCore.api.createRequest();
// 	const action = "get-list";

// 	return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
// 	.then(data => {
// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
// 					const constructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);
// 					const constructionSiteGroupsMap = {};

// 					constructionSiteList.sort((a, b) => {
// 						if (a.quotationGuid > b.quotationGuid) {
// 							return -1;
// 						}
// 						else if (a.quotationGuid < b.quotationGuid) {
// 							return 1;
// 						}
// 					});

// 					constructionSiteList.forEach(item => {
// 						if (constructionSiteGroupsMap[item.quotationGuid]) {
// 							constructionSiteGroupsMap[item.quotationGuid].push(item);
// 						}
// 						else {
// 							constructionSiteGroupsMap[item.quotationGuid] = [item];
// 						}
// 					});

// 					const constructionSiteGroupList = Object.values(constructionSiteGroupsMap);

// 					constructionSiteGroupList.forEach(group => {
// 						group.sort((a, b) => {
// 							if (a.startDate > b.startDate) {
// 								return -1;
// 							}
// 							else if (a.startDate < b.startDate) {
// 								return 1;
// 							}
// 						});

// 						group[0].__groupCSSClass = "firstOfGroup";
						
// 						if (group.length > 1) {
// 							group[group.length - 1].__groupCSSClass = "lastOfGroup";
// 						}
// 					});

// 					constructionSiteList.sort((a, b) => {
// 						if (a.startDate > b.startDate) {
// 							return -1;
// 						}
// 						else if (a.startDate < b.startDate) {
// 							return 1;
// 						}
// 					});

// 					const constructionSiteListProvinceForFilter = new Set();
// 					constructionSiteList.forEach(item => item.registry.clientProvince !== "" ? constructionSiteListProvinceForFilter.add(item.registry.clientProvince) : false);

// 					Shark.set({
// 						constructionSiteList,
// 						constructionSiteListProvinceForFilter: Array.from(constructionSiteListProvinceForFilter).sort(),
// 						constructionSiteGroupList,
// 					});

// 					constructionSiteManager.emit("listChanged");
// 					return {
// 						data: constructionSiteList,
// 						requestedAction: action,
// 						status: "ok"
// 					};
// 				case 404:
// 					constructionSiteManager.emit("listGetError");
// 					return {
// 						data,
// 						error: data.error,
// 						requestedAction: action,
// 						status: "ko"
// 					};
// 			}
// 		}
// 	});
// });

// Da buttare appena passiamo a get_filtered_list
// constructionSiteManager.addMethod("getListByAgent", function (user) {
// 	const rd = NousCore.api.createRequest({ item: { userGuid: user.guid } });
// 	const action = "get-list-by-agent";

// 	return NousCore.api.send(`${this.remoteClassName}/${action}`, rd)
// 	.then(data => {
// 		if (data.isSuccess) {
// 			switch (data.rc) {
// 				case 1:
// 					const constructionSiteList = Shark.getInstanceList("ConstructionSite", data.items);

// 					constructionSiteList.sort((a, b) => {
// 						if (a.startDate > b.startDate) {
// 							return -1;
// 						}
// 						else if (a.startDate < b.startDate) {
// 							return 1;
// 						}
// 					});

// 					const constructionSiteListProvinceForFilter = new Set();
// 					constructionSiteList.forEach(item => item.registry.clientProvince !== "" ? constructionSiteListProvinceForFilter.add(item.registry.clientProvince) : false);

// 					Shark.set({
// 						constructionSiteList,
// 						constructionSiteListProvinceForFilter: Array.from(constructionSiteListProvinceForFilter).sort(),
// 					});

// 					constructionSiteManager.emit("listChanged");
// 					return {
// 						data: constructionSiteList,
// 						requestedAction: action,
// 						status: "ok"
// 					};
// 				case 404:
// 					constructionSiteManager.emit("listGetError");
// 					return {
// 						data,
// 						error: data.error,
// 						requestedAction: action,
// 						status: "ko"
// 					};
// 			}
// 		}
// 	});
// });

// constructionSiteManager.addMethod("uploadAttachment", function (target) {
// 	return NousCore.api.uploadFiles(target, "construction-site/upload-attachment")
// 	.then(function (jsonData) {
// 		const currConstructionSite = Shark.get("currConstructionSite");
// 		const savedFiles = jsonData.payload.items;
// 		const newGuids = [];

// 		savedFiles.forEach(savedFile => {
// 			switch (savedFile.rc) {
// 				case 1:
// 					const newGuid = Shark.__generateGUID();
// 					const fileType = savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1).toLowerCase();
// 					currConstructionSite.attachments.push({
// 						guid: newGuid,
// 						fileSize: savedFile.size,
// 						label: savedFile.name,
// 						source: "constructionSite",
// 						// thumbURL: "/images/icons/" + savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1) + ".png",
// 						// type: savedFile.filePath.substr(savedFile.filePath.lastIndexOf(".") + 1),
// 						// url: Shark.get("__cdnURL") + savedFile.filePath
// 						thumbURL: savedFile.thumbnailFilPath ? "/" + savedFile.thumbnailFilPath : ["jpg", "jpeg", "png"].indexOf(fileType) > -1 ? "/" + savedFile.filePath : "/images/icons/" + fileType + ".png",
// 						type: fileType,
// 						url: "/" + savedFile.filePath,
// 					});

// 					newGuids.push(newGuid);
// 					// constructionSiteManager.emit("fileUploaded", savedFile.filePath);
// 					break;
// 				case 95:
// 					// let data = {
// 					// 	tempFile: savedFile.errors[0].erroData.tempFile,
// 					// 	originalName: savedFile.errors[0].erroData.originalName,
// 					// 	type: "pictureURL"
// 					// };
// 					// constructionSiteManager.emit("fileAlreadyPresentError", data);
// 					break;
// 				default:
// 					alert("Attezione, si è verificato il seguente errore:\n\n" + savedFile.errors[0].errorDescription);
// 			}
// 		});

// 		// Shark.render();
// 		return {
// 			data: {currConstructionSite, newGuids},
// 			status: "ok"
// 		}
// 	});
// });

Shark.registerController(constructionSiteManager);

export { constructionSiteManager };
